module.exports = __webpack_public_path__ + "static/image5_fr-ef1e2c4932aa12f96c58e615193b49a8.png";